<template>
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        Audience Builder Folders
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#"><i class="fa fa-dashboard"></i> Home</a>
        </li>
        <li class="active"> Audience Builder Folders </li>
      </ol>
    </section>
    <!-- Main content -->
    <section class="content">
      <div class="row">
        <div class="col-xs-12">
          <div class="box">
            <div class="box-body">
              <div class="col-xs-12 col-md-12 col-lg-12">
                <FolderTable />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.row -->
    </section>
    <!-- /.content -->
  </div>
</template>

<script>
// import Form from './form'
import FolderTable from './folderTable.vue'

export default {
  name: 'audience-query-list',
  components: {
    FolderTable
  }
}
</script>

<style scoped>
.value {
  font-weight: bold;
}
.form-loader img {
  width: 30px;
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// index.vue?4b3156fc